// object > Actions > Create Alert

(function() {
    'use strict';

    var TimeBasedAlertCtrl = function($scope, ajaxCall, xmsNotificationFactory, $uibModalInstance, passedModel) {

        console.log("TimeBasedAlertCtrl");

        $scope.ngModel = {};

        $scope.fnSaveAlert = function($event) {
            $event.preventDefault();

            var ajaxUrl = WEBAPP_PATH + "/timeBasedAlert/saveAlert?";
            var data    = $scope.ngModel;

            ajaxCall.getData(ajaxUrl, data).then(
                function(result) {
                    xmsNotificationFactory.addObj( {id: 'timeBasedAlertSuccess', type: 'success', bodyHtml: result.data});
                    // console.log("result.data" + result.data);
                    $uibModalInstance.close($scope.ngModel); // returnValue - the results will be passed back to xms-modal ng-model (passedModel)

                    $event.preventDefault(); // we may not need this one?
                },
                function(result) {
                    xmsNotificationFactory.addObj( {id: 'timeBasedAlertSuccess', type: 'danger', bodyHtml: result.data});
                }
            );
        }

        $scope.fnSaveAssignee = function($event) {
            $event.preventDefault();

            var ajaxUrl = WEBAPP_PATH + "/timeBasedAlert/saveAssignee?";
            var data    = $scope.ngModel;

            ajaxCall.getData(ajaxUrl, data).then(
                function(result) {
                    xmsNotificationFactory.addObj( {id: 'timeBasedAlertSuccess', type: 'success', bodyHtml: result.data});
                    // console.log("result.data" + result.data);
                    $uibModalInstance.close($scope.ngModel); // returnValue - the results will be passed back to xms-modal ng-model (passedModel)

                    $event.preventDefault(); // we may not need this one?
                },
                function(result) {
                    xmsNotificationFactory.addObj( {id: 'timeBasedAlertSuccess', type: 'danger', bodyHtml: result.data});
                }
            );
        }

        $scope.cancel = function(e) {
            if(angular.isDefined(e)){
                e.preventDefault();
            }
            $uibModalInstance.dismiss('cancel');
        }


    }
    TimeBasedAlertCtrl.$inject = ['$scope', 'ajaxCall', 'xmsNotificationFactory', '$uibModalInstance', 'params'];
    angular.module('app').controller('TimeBasedAlertCtrl', TimeBasedAlertCtrl);

}());